import React from "react";
import { PaymentOptionsEnum } from "../../../business/api";
import { SubscriptionPlanChosen, SubscriptionType } from "../../../business/core";
import { FormBankSlip } from "../../api/components";
import { PaymentOptionsFactory } from "../interfaces";

export class PaymentOptionsFactoryImpl implements PaymentOptionsFactory {
    create(paymentOptionData: string, plan: SubscriptionPlanChosen, isToUpdate?: boolean, subscriptionType?: SubscriptionType, isFree?: boolean): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
        switch (paymentOptionData) {
            case PaymentOptionsEnum.BANK_SLIP:
                return <FormBankSlip id={plan.id} frequency={plan.frequency} paymentMethod={plan.paymentMethod} isToUpdate={isToUpdate} subscriptionType={subscriptionType} isFree={isFree} />

            default:
                return <></>;
        }
    }

}